// extracted by mini-css-extract-plugin
module.exports = {"MainInfoBlockHeader":"SubHeader_MainInfoBlockHeader__2BPSb","MainInfoBlockHeaderLinksWrapper":"SubHeader_MainInfoBlockHeaderLinksWrapper__fDXs4"};